/* @ngInject */
export default function QueueDirective(NotifyingService) {
    return {
        restrict: 'AE',
        scope: {
            totalQueue: '@total',
            isDisabled: '=',
            queue: '=',
            compareFn: '&',
            cancelFn: '&',
            onRemove: '&'
        },
        templateUrl: require('./queue.directive.html'),
        link: function (scope) {
            scope.updateEmptyQueue = function () {
                scope.emptyQueue = [];
                for (var i = 0; i < (parseInt(scope.totalQueue) - scope.queue.length); ++i) {
                    scope.emptyQueue.push(i);
                }
            };

            scope.$watchCollection('queue', function () {
                scope.updateEmptyQueue();
            });

            scope.updateEmptyQueue();

            scope.remove = function (item) {
                let index = scope.queue.indexOf(item);
                scope.queue.splice(index, 1);
                if (scope.onRemove()) {
                    scope.onRemove()(item);
                }
            };

            scope.compare = function () {
                if (scope.compareFn()) {
                    scope.compareFn()();
                }
            };

            scope.cancel = function () {
                if (scope.cancelFn()) {
                    scope.cancelFn()();
                }
            };

            scope.removeDetectedSearch = function () {
                var compareQueue = scope.queue;
                for (var i = 0; i < compareQueue.length; i++) {
                    if (compareQueue[i].type !== undefined) {
                        scope.remove(compareQueue[i]);
                    }
                }
            };

            NotifyingService.subscribeToSleuthChanges(scope, scope.removeDetectedSearch());
            NotifyingService.subscribeToNullSleuthResult(scope, scope.removeDetectedSearch());
        }
    };
}
